import { useQuery } from '@fv/client-core'
import type { LoadTemplateDTO } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

export const loadTemplateKeys = {
  all: ['load-templates'] as const,
}

export const useLoadTemplates = () => {
  return useQuery(loadTemplateKeys.all, () =>
    shipperFetch<LoadTemplateDTO[]>('/load-templates'),
  )
}
